import { makeColorToken } from '@utils/css';

const cardListTransitionDurationMs = 225;
makeColorToken("--background-color", "255 255 255");
const wrapper = "_61w1lyrpjk";
const panel = "_61p1q9aj8s";
const title = "_61t11ztmm7";
const titleIcon = "_61t13bsptt";
const cardList = "_61c18t7drg";

export { cardList, cardListTransitionDurationMs, panel, title, titleIcon, wrapper };
import "./_resource.style.linaria.module.css";
//# sourceMappingURL=_resource.style.js.map
